((Drupal) => {
  const facetedViews = (context) => {
    const facetedViewContents = context.querySelectorAll(
      ".faceted-view-content"
    );

    facetedViewContents.forEach((viewContent) => {
      const viewHeader = viewContent
        .closest(".view")
        ?.querySelector(".view-header");

      if (!viewHeader) return;

      // Hide the view header and content by default
      viewContent.classList.add("visually-hidden");
      viewHeader.classList.add("visually-hidden");

      // See how many views-view-grid items are in the grid
      const numItems = viewContent.querySelectorAll(".views-view-grid").length;

      // Only reveal the view content if there's just one item
      if (numItems === 1) {
        viewContent.classList.remove("visually-hidden");
        viewHeader.classList.remove("visually-hidden");
      }
    });
  };

  Drupal.behaviors.facetedViews = {
    attach(context) {
      facetedViews(context);
    },
  };
})(Drupal);
